function formatPower(val) {
  const num = parseFloat(val);
  return isNaN(num) ? val : num.toFixed(2);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// Color swatch hover effect - shows color name on hover
(function initColorSwatchHover() {
  // Supporta sia color standard che multipack (first pair color, second pair color, third pair color)
  const colorAttributes = [
    'color',
    'first pair color',
    'second pair color', 
    'third pair color'
  ];
  
  function getColorFieldset(label) {
    for (const attr of colorAttributes) {
      const fieldset = label.closest(`fieldset[data-variant-attribute="${attr}"]`);
      if (fieldset) return fieldset;
    }
    return null;
  }

  function getVariantForFieldsetValue(variantSelects, targetFieldset, targetValue) {
    if (!variantSelects || !targetFieldset) return null;

    const options = Array.from(variantSelects.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') return element.value;
      if (element.tagName === 'FIELDSET') {
        if (element === targetFieldset) return targetValue;
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
      return undefined;
    });

    const variantData = typeof variantSelects.getVariantData === 'function'
      ? variantSelects.getVariantData()
      : [];

    return variantData.find((variant) => {
      return !variant.options
        .map((option, index) => options[index] === option)
        .includes(false);
    }) || null;
  }

  function getVariantFromCurrentSelection(variantSelects) {
    if (!variantSelects) return null;

    const options = Array.from(variantSelects.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') return element.value;
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
      return undefined;
    });

    const variantData = typeof variantSelects.getVariantData === 'function'
      ? variantSelects.getVariantData()
      : [];

    return variantData.find((variant) => {
      return !variant.options
        .map((option, index) => options[index] === option)
        .includes(false);
    }) || null;
  }

  function applyHoverGalleryPreview(variantSelects, variant) {
    if (!variantSelects || !variant) return;

    const selectedVariantBeforeHover = variantSelects.currentVariant;
    const selectedCustomVariantBeforeHover = variantSelects.customCurrentVariant;

    // Keep hover preview isolated from selected state used by variant-change async flow.
    variantSelects.currentVariant = variant;

    try {
      if (typeof variantSelects.getCustomData === 'function') {
        variantSelects.customCurrentVariant = variantSelects.getCustomData().find((item) => item.id === variant.id) || null;
      }
    } catch (e) {
      variantSelects.customCurrentVariant = null;
    }

    if (typeof variantSelects.updatePdpGalleryGrid === 'function') {
      variantSelects.updatePdpGalleryGrid();
    }

    if (typeof variantSelects.updateMedia === 'function') {
      variantSelects.updateMedia();
    }

    variantSelects.currentVariant = selectedVariantBeforeHover;
    variantSelects.customCurrentVariant = selectedCustomVariantBeforeHover;
  }
  
  document.addEventListener('mouseenter', function(e) {
    if (!e.target || !e.target.closest) return;
    const label = e.target.closest('label.pdp-color-swatch');
    if (!label) return;
    
    const input = document.getElementById(label.getAttribute('for'));
    if (!input) return;
    
    const fieldset = getColorFieldset(label);
    if (!fieldset) return;
    
    const colorNameSpan = fieldset.querySelector('[class*="form__label--option"]');
    if (!colorNameSpan) return;
    
    // Save current value in data attribute
    if (!fieldset.dataset.currentColor) {
      fieldset.dataset.currentColor = colorNameSpan.innerHTML;
    }
    
    // Show hovered color name
    colorNameSpan.innerHTML = input.value;

    const variantSelects = label.closest('variant-selects');
    if (!variantSelects) return;
    if (input.classList.contains('disabled')) return;

    const hoverVariant = getVariantForFieldsetValue(variantSelects, fieldset, input.value);
    applyHoverGalleryPreview(variantSelects, hoverVariant);
  }, true);
  
  document.addEventListener('mouseleave', function(e) {
    if (!e.target || !e.target.closest) return;
    const label = e.target.closest('label.pdp-color-swatch');
    if (!label) return;
    
    const fieldset = getColorFieldset(label);
    if (!fieldset) return;
    
    const colorNameSpan = fieldset.querySelector('[class*="form__label--option"]');
    if (!colorNameSpan) return;
    
    // Restore to checked color value
    const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
    if (checkedInput) {
      colorNameSpan.innerHTML = checkedInput.value;
      fieldset.dataset.currentColor = checkedInput.value;
    } else if (fieldset.dataset.currentColor) {
      colorNameSpan.innerHTML = fieldset.dataset.currentColor;
    }

    const variantSelects = label.closest('variant-selects');
    if (!variantSelects) return;

    const selectedVariant = getVariantFromCurrentSelection(variantSelects);
    applyHoverGalleryPreview(variantSelects, selectedVariant);
  }, true);
})();

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  //removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('.quantity__button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const button = event.target.closest('.quantity__button');
    if (!button) return;
    const action = button.getAttribute('name');
    const previousValue = this.input.value;
    const min = this.input.min ? parseInt(this.input.min) : null;
    const max = this.input.max ? parseInt(this.input.max) : null;

    console.log('[QuantityInput] click:', action, '| current value:', previousValue, '| min:', min, '| max:', max);

    action === 'plus' ? this.input.stepUp() : this.input.stepDown();

    console.log('[QuantityInput] new value:', this.input.value);

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      if (buttonMinus) {
        buttonMinus.classList.toggle('disabled', value <= min);
      }
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      if (buttonPlus) {
        buttonPlus.classList.toggle('disabled', value >= max);
      }
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var redirectUrl = options['redirectUrl'];

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);

  if (redirectUrl) {
    fetch(path, {
      method: method,
      body: new URLSearchParams(new FormData(form))
    }).then(function (response) {
      if (response.ok) {
        window.location.href = redirectUrl;
      } else {
        console.error('Submit failed');
      }
    }).catch(function (error) {
      console.error('Error:', error);
    });
  } else {
    form.submit();
  }

  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const prevActiveElement = detailsElement.parentNode.parentNode.querySelector('details[open]');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 999px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      if (prevActiveElement !== null && prevActiveElement !== detailsElement) {
        if (!prevActiveElement.contains(detailsElement)) {
          prevActiveElement.removeAttribute('open');
          const prevChildActiveElement = prevActiveElement.querySelector('details[open]');
          if (prevChildActiveElement !== null) {
            prevChildActiveElement.removeAttribute('open');
          }
        }
      }
      setTimeout(() => {
        // detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.querySelectorAll('.popup-close-button').forEach(button => {
      button.addEventListener('click', this.hide.bind(this, false));
    });
    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;

    button.addEventListener('click', (e) => {
      e.preventDefault();
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    if (this.sliderItems.length == 1) {
      this.querySelectorAll(".slider-button")?.forEach(button => button.style.display = "none");
    };
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  static get observedAttributes() {
    return ['data-reset'];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    //console.log(`Attribute ${name} has changed from ${oldValue} to ${newValue}.`);
    if (oldValue == "false") {
      this.resetPages();
      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      this.setAttribute('data-reset', "false");
    }
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    if (!this.sliderItems.length) return;
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    if (!currentSlide || !nextSlide) return;

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    
    // Subscribe to variant change events for low stock message
    subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChangeForLowStock.bind(this));
    
    this.productType = this.dataset.productType;
    this.variantData = this.getVariantData();
  }

  connectedCallback() {
    if (this.productType == 'Multipack') {
      this.updateVariantStatusesMultipack();
    } else {
      this.updateVariantStatuses();
    }

    // Add click handlers for lens type buttons
    this.querySelectorAll('.tw-lens-type-option').forEach((button) => {
      button.addEventListener('click', () => {
        const input = button.querySelector('input[type="radio"]');
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // Update selected options on page load
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedOptions();
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (this.productType == 'Multipack') {
      this.updateVariantStatusesMultipack();
    } else {
      this.updateVariantStatuses();
    }

    // Check if product has multiple lens types
    const lensTypeFieldset = document.querySelector('[data-variant-attribute="lens type"]');
    const hasMultipleLensTypes = lensTypeFieldset && lensTypeFieldset.querySelectorAll('input[type="radio"]').length > 1;

    if (hasMultipleLensTypes) {
      // Logic for products with multiple lens types
      if (!this.currentVariant) {
        const buyButtonBlock = document.getElementById(`BuyButtonsBlock-${this.dataset.section}`);
        if (buyButtonBlock) {
          buyButtonBlock.setAttribute('data-available', 'false');
        }
        this.updateShopPayInstallmentsVisibility();
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        // Set data-available based on variant availability
        const buyButtonBlock = document.getElementById(`BuyButtonsBlock-${this.dataset.section}`);
        if (buyButtonBlock) {
          buyButtonBlock.setAttribute('data-available', this.currentVariant.available);
        }
        
        // Try to get customCurrentVariant (may fail due to malformed JSON)
        try {
          this.customCurrentVariant = this.getCustomData().find(variant => variant.id === this.currentVariant.id);
        } catch (e) {
          this.customCurrentVariant = null;
        }

        this.updateSelectedOptions();
        this.updateSwiperGallery();
        this.updateModalGallery();
        this.updatePdpGalleryGrid();
        this.updateFeatures();
        this.updateLowStockMessage();
        
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.updateShopPayInstallmentsVisibility();
        this.renderProductInfo();
        this.updateShareUrl();
        this.updateSticky();
      }
    } else {
      // Original logic for products with single lens type
      try {
        this.customCurrentVariant = this.getCustomData().find(variant => variant.id === this.currentVariant.id);
      } catch (e) {
        this.customCurrentVariant = null;
      }

      this.updateSelectedOptions();
      this.updateSwiperGallery();
      this.updateModalGallery();
      this.updatePdpGalleryGrid();
      this.updateFeatures();
      this.updateLowStockMessage();

      if (!this.currentVariant) {
        this.updateShopPayInstallmentsVisibility();
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.updateShopPayInstallmentsVisibility();
        this.renderProductInfo();
        this.updateShareUrl();
        this.updateSticky();
      }
    }
  }

  updateSticky() {
    if (this.customCurrentVariant != null && this.customCurrentVariant != undefined) {
      var variantId = this.customCurrentVariant.id;
      let prices = document.querySelectorAll('#stickyAddToCart .showpricing');
      prices.forEach((price) => {
        price.classList.add("tw-hidden");
      }
      );
      document.querySelector('#prices-' + variantId).classList.remove("tw-hidden");

      if (this.customCurrentVariant.available) {
        document.querySelector('#stickyAddToCart button').classList.remove("tw-opacity-60");
        document.querySelector('#stickyAddToCart button').removeAttribute('disabled');
        document.querySelector('#stickyAddToCart .sticky-variant-id').value = variantId;
      } else {
        document.querySelector('#stickyAddToCart button').classList.add("tw-opacity-60");
        document.querySelector('#stickyAddToCart button').setAttribute('disabled', 'disabled');
      }
    }
  }

  updateLowStockMessage() {
    this.handleVariantChangeForLowStock({
      data: {
        variant: this.currentVariant
      }
    });
  }

  handleVariantChangeForLowStock(event) {
    const variant = event?.data?.variant;
    const lowStockMessage = document.querySelector('.power-low-stock-message');
    
    if (!lowStockMessage || !variant) return;

    const inventoryDataElement = document.querySelector('#VariantInventoryData');
    if (!inventoryDataElement) return;
    
    const inventoryData = JSON.parse(inventoryDataElement.textContent);
    const qty = inventoryData[variant.id];
    
    if (typeof qty !== 'undefined' && qty > 0 && qty <= 10) {
      const qtySpan = lowStockMessage.querySelector('.power-low-stock-qty');
      qtySpan.textContent = qty;
      lowStockMessage.style.display = '';
    } else {
      lowStockMessage.style.display = 'none';
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-installment-buy-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateShopPayInstallmentsVisibility() {
    const wrapper = document.getElementById(`ShopPayInstallments-${this.dataset.section}`);
    if (!wrapper) return;

    const isAvailable = !!(this.currentVariant && this.currentVariant.available);
    wrapper.style.display = isAvailable ? '' : 'none';
    wrapper.setAttribute('aria-hidden', (!isAvailable).toString());
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      if (index == 1) {
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        var nextOptionSelected = null;
        if (inputWrappers[index + 1] != null) {
          nextOptionSelected = inputWrappers[index + 1].querySelector(':checked').value;
        }
        this.setInputAvailability(optionInputs, index, [previousOptionSelected, nextOptionSelected], selectedOptionOneVariants);
      } else if (index == 2) {
        const firstOptionSelected = inputWrappers[index - 2].querySelector(':checked').value;
        const secondOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        this.setInputAvailability(optionInputs, index, [firstOptionSelected, secondOptionSelected], selectedOptionOneVariants);
      }
    });

    // Update lens type buttons availability based on selected power
    this.updateLensTypeButtonsAvailability();
  }

  updateLensTypeButtonsAvailability() {
    const lensTypeButtons = this.querySelectorAll('.tw-lens-type-option');
    if (lensTypeButtons.length === 0) return;

    // Get selected power (option2)
    const powerFieldset = this.querySelector('[data-variant-attribute="power"]');
    if (!powerFieldset) return;
    const selectedPower = powerFieldset.querySelector('input:checked')?.value;
    if (!selectedPower) return;

    lensTypeButtons.forEach((button) => {
      const lensType = button.dataset.lensTypeValue;
      const input = button.querySelector('input[type="radio"]');
      const isSelected = input?.checked || false;

      // Check if any variant with this lens type + selected power is available
      const isAvailable = this.variantData.some((variant) => 
        variant.option1 === lensType && 
        variant.option2 === selectedPower && 
        variant.available
      );

      // Update button styles based on 4 states
      if (isSelected && isAvailable) {
        button.style.border = '1.5px solid #45423D';
        button.style.background = '#FFF';
      } else if (isSelected && !isAvailable) {
        button.style.border = '1.5px solid #45423D';
        button.style.background = '#F5F5F4';
      } else if (!isSelected && isAvailable) {
        button.style.border = '1px solid #D8D8D8';
        button.style.background = '#FFF';
      } else {
        button.style.border = '1px solid #D8D8D8';
        button.style.background = '#F5F5F4';
      }

      button.dataset.inStock = isAvailable.toString();
      button.dataset.selected = isSelected.toString();
    });
  }

  setInputAvailability(elementList, index, currentValues, selectedOptionOneVariants) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      if (index == 1) {
        if (currentValues[1] == null) {
          var availableElement = selectedOptionOneVariants.filter((variant) => variant.available && variant.options[0] === currentValues[0] && variant.options[1] === value);
        } else {
          var availableElement = selectedOptionOneVariants.filter((variant) => variant.available && variant.options[0] === currentValues[0] && variant.options[1] === value && variant.options[2] === currentValues[1]);
        }
      } else {
        var availableElement = selectedOptionOneVariants.filter((variant) => variant.available && variant.options[0] === currentValues[0] && variant.options[1] === currentValues[1] && variant.options[2] === value);
      }

      if (availableElement.length == 0) {
        availableElement = false;
      } else {
        availableElement = true;
      }

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }


  updateVariantStatusesMultipack() {
    const firstChecked = this.querySelector(':checked');
    if (!firstChecked) return;
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => firstChecked.value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const prevChecked = inputWrappers[index - 1].querySelector(':checked');
      if (!prevChecked) return;
      const previousOptionSelected = prevChecked.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailabilityMultipack(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailabilityMultipack(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        const videoPartDestination = document.querySelectorAll(`.product-videos-part`);
        const videoPartSource = html.querySelector(`.product-videos-part`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        // Aggiornamento delle parti video
        if (videoPartDestination) {
          videoPartDestination.forEach(elementDestination => {
            elementDestination.innerHTML = videoPartSource.innerHTML
          });
        }

        // Aggiornamento prezzo mobile
        const priceMobileDestination = document.getElementById(`price-mobile-${this.dataset.section}`);
        if (source && priceMobileDestination) priceMobileDestination.innerHTML = source.innerHTML;

        // Aggiornamento prezzo bottom section
        const priceBottomDestination = document.getElementById(`price-bottom-${this.dataset.section}`);
        if (source && priceBottomDestination) priceBottomDestination.innerHTML = source.innerHTML;

        // Aggiornamento data attribute blocco "buy buttons"
        const buyButtonBlock = document.getElementById(`BuyButtonsBlock-${this.dataset.section}`);
        if (buyButtonBlock) {
          buyButtonBlock.setAttribute('data-available', this.currentVariant.available);
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart.toUpperCase();
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  // Update delle option selezionate
  updateSelectedOptions() {
    let variantOption1Label = this.querySelector('.form__label--option1');
    let variantOption2Label = this.querySelector('.form__label--option2');
    let variantOption3Label = this.querySelector('.form__label--option3');

    if (variantOption1Label) {
      if (variantOption1Label.closest('[data-variant-attribute="power"]') != null) {
        variantOption1Label.innerHTML = '+' + formatPower(this.currentVariant.option1);
      } else {
        variantOption1Label.innerHTML = this.currentVariant.option1;
        // Update lens type tooltip in product-info el
        let customCurrentVariant = this.getCustomData().find(variant => variant.id === this.currentVariant.id);
        if (customCurrentVariant && customCurrentVariant['lenstype_tooltip'] != null) {
          const tooltip_text = variantOption1Label.closest('.form__label--selected-option').querySelector('.tw-tooltip-text > p')
          tooltip_text ? tooltip_text.innerHTML = customCurrentVariant.lenstype_tooltip : null;
        }
      }
    }
    if (variantOption2Label) {
      if (variantOption2Label.closest('[data-variant-attribute="power"]') != null) {
        variantOption2Label.innerHTML = '+' + formatPower(this.currentVariant.option2);
      } else {
        variantOption2Label.innerHTML = this.currentVariant.option2;
      }
    }
    if (variantOption3Label) {
      if (variantOption3Label.closest('[data-variant-attribute="power"]') != null) {
        variantOption3Label.innerHTML = '+' + formatPower(this.currentVariant.option3);
      } else {
        variantOption3Label.innerHTML = this.currentVariant.option3;
      }
    }
  }

  updateSwiperGallery() {
    if (!this.customCurrentVariant) return;
    
    //utility function to get the src image parts based on the env cause staging have different img names
    const getSrcImgParts = (hostname, src) => {
      switch (hostname) {
        case 'readers-staging.myshopify.com':
          const parts = src.split('/');
          if (parts.length > 1) {
            return parts[1].split('.')[0].split('_')[0].toLowerCase();
          }
        default:
          if (src && src.split('/').length > 1) {
            let string = src.split('/')[1].split('.')[0].toLowerCase();
            string.includes('_') ? string = string.split('_')[0] : string = string;
            return string;
          }
      }
    }

    const parser = new DOMParser();
    
    // Check if pdp-swiper exists before updating
    const swiperWrapper = document.querySelector('pdp-swiper .swiper-wrapper');
    if (!swiperWrapper) {
      return;
    }

    if (this.customCurrentVariant.meta_images && this.customCurrentVariant.meta_images != "#N/D") {
      // Vengono rimosse le slides vecchie
      let slideToRemove = document.querySelectorAll('pdp-swiper .swiper-slide');
      slideToRemove.forEach((slide) => {
        slide.remove();
      });

      // Vengono cercate le nuove slides con metafield della variante e aggiunte al DOM
      this.metaVariantImages = this.customCurrentVariant.meta_images.split(',').map(img => {
        let key = img.toLowerCase().trim();
        const dotIdx = key.indexOf('.');
        return dotIdx > 0 ? key.substring(0, dotIdx) : key;
      });
      let scriptSlides = document.querySelectorAll('.script-gallery-images script');
      scriptSlides.forEach((script) => {
        this.metaVariantImages.forEach((metaImg) => {
          const scriptImg = getSrcImgParts(window.location.hostname, script.getAttribute('data-img-src'));
          if (scriptImg == metaImg) {
            let htmlDoc = parser.parseFromString(script.innerHTML, 'text/html');
            swiperWrapper.appendChild(htmlDoc.querySelector('.swiper-slide'));
          }
        });
      });
    }

    // Triggera l'update del component e di conseguenza l'update dello slider
    let pdpSwiper = document.querySelector('pdp-swiper');
    if (pdpSwiper) {
      pdpSwiper.setAttribute('data-reset', 'true');
    }

  }

  // Viene preso un JSON creato apposta per maggiori info della variante 
  getCustomData() {
    this.customVariantData = JSON.parse(this.querySelector('#CustomVariantsScript').textContent);
    return this.customVariantData;
  }

  updateModalGallery() {
    if (!this.customCurrentVariant) return;
    
    const parser = new DOMParser();

    if (this.customCurrentVariant.meta_images) {
      const slideshow = document.querySelector('custom-product-modal .slideshow');
      if (!slideshow) return;
      
      // Remove all slides
      let slideToRemove = document.querySelectorAll('custom-product-modal .slideshow__slide');
      slideToRemove.forEach((slide) => {
        slide.remove();
      });

      // Vengono cercate le nuove slides con metafield della variante e aggiunte al DOM
      this.metaVariantImages = this.customCurrentVariant.meta_images.split(',').map(img => {
        let key = img.toLowerCase().trim();
        const dotIdx = key.indexOf('.');
        return dotIdx > 0 ? key.substring(0, dotIdx) : key;
      });
      let scriptSlides = document.querySelectorAll('.script-modal-images script');
      
      // Collect new slides to add
      const newSlides = [];
      scriptSlides.forEach((script) => {
        this.metaVariantImages.forEach((metaImg) => {
          if (script.getAttribute('data-img-src') == metaImg) {
            let htmlDoc = parser.parseFromString(script.innerHTML, 'text/html');
            const slide = htmlDoc.querySelector('.slideshow__slide');
            if (slide) {
              newSlides.push({ slide, src: metaImg });
            }
          }
        });
      });
      
      // Sort new slides by meta_images order
      newSlides.sort((a, b) => {
        const indexA = this.metaVariantImages.indexOf(a.src);
        const indexB = this.metaVariantImages.indexOf(b.src);
        return indexA - indexB;
      });
      
      // Clear slideshow and rebuild with correct order:
      // 1. First product image
      // 2. Placeholder slides (if any)
      // Add all slides
      slideshow.innerHTML = '';
      
      // Add all product images in order
      newSlides.forEach((slideData) => {
        slideshow.appendChild(slideData.slide);
      });

      // Update counter total to match actual number of slides
      const counterTotal = document.querySelector('custom-product-modal .slider-counter--total');
      if (counterTotal) {
        counterTotal.textContent = newSlides.length.toString();
      }
      const counterCurrent = document.querySelector('custom-product-modal .slider-counter--current');
      if (counterCurrent) {
        counterCurrent.textContent = '1';
      }

      // Triggera l'update del component e di conseguenza l'update dello slider
      let modalSlider = document.querySelector('.modal-slideshow-component');
      if (modalSlider) {
        modalSlider.setAttribute('data-reset', 'true');
      }
    }

  }

  updatePdpGalleryGrid() {
    // Check how many pdp-gallery-grid elements exist
    const allGalleryGrids = document.querySelectorAll('pdp-gallery-grid');

    const pdpGalleryGrid = document.querySelector('pdp-gallery-grid');
    if (!pdpGalleryGrid) return;

    if (this.customCurrentVariant && this.customCurrentVariant.meta_images && this.customCurrentVariant.meta_images != "#N/D") {
      const parser = new DOMParser();
      
      // Get variant images array from metafield (strip file extension for matching)
      const metaVariantImages = this.customCurrentVariant.meta_images.split(',').map(img => {
        let key = img.toLowerCase().trim();
        const dotIdx = key.indexOf('.');
        return dotIdx > 0 ? key.substring(0, dotIdx) : key;
      });
      
      // Use the ALL product images container for variant change filtering
      const scriptTags = pdpGalleryGrid.querySelectorAll('.pdp-gallery-grid__all-product-images script');
      if (scriptTags.length === 0) return;

      // Build filtered images array
      const filteredImages = [];
      scriptTags.forEach((script) => {
        const imgSrc = script.getAttribute('data-img-src') || '';
        const srcKey = imgSrc.toLowerCase();
        
        // Check if this image matches any of the variant's meta_images
        if (metaVariantImages.includes(srcKey)) {
          filteredImages.push({
            mediaId: script.getAttribute('data-media-id'),
            imgSrc: srcKey,
            fullSrc: script.getAttribute('data-full-src') || '',
            alt: script.getAttribute('data-alt') || '',
            html: script.innerHTML
          });
        }
      });

      // Sort images based on meta_images order
      filteredImages.sort((a, b) => {
        const indexA = metaVariantImages.indexOf(a.imgSrc);
        const indexB = metaVariantImages.indexOf(b.imgSrc);
        return indexA - indexB;
      });

      // Update gallery if we have matching images
      if (filteredImages.length > 0) {
        // UPDATE MAIN IMAGE (first image of variant)
        const mainImageContainer = pdpGalleryGrid.querySelector('.pdp-gallery-grid__main-image');
        const sectionId = pdpGalleryGrid.dataset.sectionId || '';
        
        if (mainImageContainer) {
          const firstImage = filteredImages[0];
          
          // Update main image data-media-id for expand functionality
          mainImageContainer.setAttribute('data-media-id', `${sectionId}-${firstImage.mediaId}`);
          
          // The main image is inside modal-opener > .product__media > img
          const mainImg = mainImageContainer.querySelector('.product__media img');
          if (mainImg && firstImage.fullSrc) {
            // Update main image src and srcset
            const newSrc = firstImage.fullSrc;
            // Build srcset with multiple sizes
            const baseSrc = newSrc.replace(/width=\d+/, 'width=');
            mainImg.src = newSrc;
            mainImg.srcset = `
              ${baseSrc.replace('width=', 'width=493')} 493w,
              ${baseSrc.replace('width=', 'width=600')} 600w,
              ${baseSrc.replace('width=', 'width=823')} 823w,
              ${baseSrc.replace('width=', 'width=990')} 990w,
              ${baseSrc.replace('width=', 'width=1200')} 1200w
            `;
            mainImg.alt = firstImage.alt;
          }
        }

        const thumbnailsContainer = pdpGalleryGrid.querySelector('.pdp-gallery-grid__thumbnails');
        if (!thumbnailsContainer) return;

        // Clear existing thumbnails
        thumbnailsContainer.innerHTML = '';

        const maxVisibleThumbs = 4;
        // Skip first image (main image) for thumbnails
        const thumbnailImages = filteredImages.slice(1);
        const totalThumbnails = thumbnailImages.length;
        // +1 because the last tile with "+N" also represents itself (the image that would be in that slot)
        const remainingImages = totalThumbnails > maxVisibleThumbs ? totalThumbnails - maxVisibleThumbs + 1 : 0;

        // Add filtered thumbnails (skip first image as it's the main image)
        thumbnailImages.slice(0, maxVisibleThumbs).forEach((data, index) => {
          const htmlDoc = parser.parseFromString(data.html, 'text/html');
          const thumbElement = htmlDoc.querySelector('.pdp-gallery-grid__thumb');
          
          if (thumbElement) {
            thumbElement.setAttribute('data-index', String(index));
            
            // Add +N overlay to last visible thumbnail if there are more images (only if > 1 remaining)
            if (index === maxVisibleThumbs - 1 && remainingImages > 1) {
              thumbElement.classList.add('pdp-gallery-grid__thumb--more');
              const overlay = document.createElement('div');
              overlay.className = 'pdp-gallery-grid__more-overlay';
              overlay.innerHTML = `<span class="pdp-gallery-grid__more-count">+${remainingImages}</span>`;
              thumbElement.appendChild(overlay);
            }
            
            thumbnailsContainer.appendChild(thumbElement);
          }
        });

        // Update the hidden filtered images container for expand functionality (keep all images for modal)
        const filteredContainer = pdpGalleryGrid.querySelector('.pdp-gallery-grid__all-images');
        if (filteredContainer) {
          filteredContainer.innerHTML = '';
          filteredImages.forEach((data) => {
            const script = document.createElement('script');
            script.type = 'text/html';
            script.setAttribute('data-media-id', data.mediaId);
            script.setAttribute('data-img-src', data.imgSrc);
            script.setAttribute('data-alt', data.alt);
            script.setAttribute('data-full-src', data.fullSrc);
            script.innerHTML = data.html;
            filteredContainer.appendChild(script);
          });
        }

        // Update pdp-gallery-grid internal data and rebind events
        const wasExpanded = pdpGalleryGrid.expanded;
        pdpGalleryGrid.allImagesData = filteredImages;
        pdpGalleryGrid.expanded = false;
        
        // Re-query thumbnails and rebind
        pdpGalleryGrid.thumbnails = pdpGalleryGrid.querySelectorAll('.pdp-gallery-grid__thumb');
        pdpGalleryGrid.currentIndex = 0;
        pdpGalleryGrid.bindEvents();

        // If gallery was expanded before rebuild, re-expand it
        if (wasExpanded && typeof pdpGalleryGrid.expandThumbnails === 'function') {
          pdpGalleryGrid.expandThumbnails();
        }
        
        // UPDATE MOBILE SWIPER
        this.updateMobileSwiper(pdpGalleryGrid, filteredImages);
      }
    } else {
      // Fallback: try to filter by color name when meta_images is not available
      
      if (this.customCurrentVariant && this.customCurrentVariant.color) {
        const variantColor = this.customCurrentVariant.color.toLowerCase();
        // Split color by common separators (/, space)
        const colorParts = variantColor.split(/[\/\s]+/).filter(c => c.length > 0);
        
        const parser = new DOMParser();
        const scriptTags = pdpGalleryGrid.querySelectorAll('.pdp-gallery-grid__all-product-images script');
        
        if (scriptTags.length > 0) {
          const filteredImages = [];
          
          scriptTags.forEach((script) => {
            const imgSrc = script.getAttribute('data-img-src') || '';
            const srcLower = imgSrc.toLowerCase();
            
            // Check if any color part matches the image src
            const colorMatch = colorParts.some(colorPart => srcLower.includes(colorPart));
            
            if (colorMatch) {
              filteredImages.push({
                mediaId: script.getAttribute('data-media-id'),
                imgSrc: imgSrc,
                fullSrc: script.getAttribute('data-full-src') || '',
                alt: script.getAttribute('data-alt') || '',
                html: script.innerHTML
              });
            }
          });
          
          // If we found images by color, update the gallery
          if (filteredImages.length > 0) {
            // UPDATE MAIN IMAGE
            const mainImageContainer = pdpGalleryGrid.querySelector('.pdp-gallery-grid__main-image');
            if (mainImageContainer) {
              const firstImage = filteredImages[0];
              const mainImg = mainImageContainer.querySelector('.product__media img');
              if (mainImg && firstImage.fullSrc) {
                const newSrc = firstImage.fullSrc;
                const baseSrc = newSrc.replace(/width=\d+/, 'width=');
                mainImg.src = newSrc;
                mainImg.srcset = `
                  ${baseSrc.replace('width=', 'width=493')} 493w,
                  ${baseSrc.replace('width=', 'width=600')} 600w,
                  ${baseSrc.replace('width=', 'width=823')} 823w,
                  ${baseSrc.replace('width=', 'width=990')} 990w,
                  ${baseSrc.replace('width=', 'width=1200')} 1200w
                `;
                mainImg.alt = firstImage.alt;
              }
            }

            const thumbnailsContainer = pdpGalleryGrid.querySelector('.pdp-gallery-grid__thumbnails');
            if (thumbnailsContainer) {
              thumbnailsContainer.innerHTML = '';
              
              const maxVisibleThumbs = 4;
              // Skip first image (main image) for thumbnails
              const thumbnailImages = filteredImages.slice(1);
              const totalThumbnails = thumbnailImages.length;
              // +1 because the last tile with "+N" also represents itself (the image that would be in that slot)
              const remainingImages = totalThumbnails > maxVisibleThumbs ? totalThumbnails - maxVisibleThumbs + 1 : 0;

              thumbnailImages.slice(0, maxVisibleThumbs).forEach((data, index) => {
                const htmlDoc = parser.parseFromString(data.html, 'text/html');
                const thumbElement = htmlDoc.querySelector('.pdp-gallery-grid__thumb');
                
                if (thumbElement) {
                  thumbElement.setAttribute('data-index', String(index));
                  
                  if (index === maxVisibleThumbs - 1 && remainingImages > 1) {
                    thumbElement.classList.add('pdp-gallery-grid__thumb--more');
                    const overlay = document.createElement('div');
                    overlay.className = 'pdp-gallery-grid__more-overlay';
                    overlay.innerHTML = `<span class="pdp-gallery-grid__more-count">+${remainingImages}</span>`;
                    thumbElement.appendChild(overlay);
                  }
                  
                  thumbnailsContainer.appendChild(thumbElement);
                }
              });

              // Update filtered container (keep all images for modal)
              const filteredContainer = pdpGalleryGrid.querySelector('.pdp-gallery-grid__all-images');
              if (filteredContainer) {
                filteredContainer.innerHTML = '';
                filteredImages.forEach((data) => {
                  const script = document.createElement('script');
                  script.type = 'text/html';
                  script.setAttribute('data-media-id', data.mediaId);
                  script.setAttribute('data-img-src', data.imgSrc);
                  script.setAttribute('data-alt', data.alt);
                  script.setAttribute('data-full-src', data.fullSrc);
                  script.innerHTML = data.html;
                  filteredContainer.appendChild(script);
                });
              }

              const wasExpandedFallback = pdpGalleryGrid.expanded;
              pdpGalleryGrid.allImagesData = filteredImages;
              pdpGalleryGrid.expanded = false;
              pdpGalleryGrid.thumbnails = pdpGalleryGrid.querySelectorAll('.pdp-gallery-grid__thumb');
              pdpGalleryGrid.currentIndex = 0;
              pdpGalleryGrid.bindEvents();

              // If gallery was expanded before rebuild, re-expand it
              if (wasExpandedFallback && typeof pdpGalleryGrid.expandThumbnails === 'function') {
                pdpGalleryGrid.expandThumbnails();
              }
              
              // UPDATE MOBILE SWIPER (color fallback)
              this.updateMobileSwiper(pdpGalleryGrid, filteredImages);
            }
          }
        }
      }
    }
  }

  // Update Mobile Swiper slides for variant change
  updateMobileSwiper(pdpGalleryGrid, filteredImages) {
    const mobileSwiper = pdpGalleryGrid.querySelector('.pdp-gallery-grid__mobile-swiper');
    if (!mobileSwiper) {
      return;
    }
    
    const mobileSlidesContainer = mobileSwiper.querySelector('.pdp-gallery-grid__mobile-slides');
    const mobileProgress = mobileSwiper.querySelector('.pdp-gallery-grid__mobile-progress');
    const mobileCounterTotal = mobileSwiper.querySelector('.pdp-gallery-grid__mobile-counter-total');
    const mobileCounterCurrent = mobileSwiper.querySelector('.pdp-gallery-grid__mobile-counter-current');
    
    if (!mobileSlidesContainer) {
      return;
    }
    
    // Check if product is accessory (no placeholders for accessories)
    const isAccessory = pdpGalleryGrid.closest('.product')?.classList.contains('product--accessory') || 
                        document.querySelector('.product-type-accessory') !== null ||
                        pdpGalleryGrid.dataset.isAccessory === 'true';
    
    // Get existing placeholder slides to preserve them
    const existingPlaceholders = mobileSlidesContainer.querySelectorAll('.pdp-gallery-grid__mobile-slide--placeholder');
    const placeholderData = [];
    existingPlaceholders.forEach(placeholder => {
      const img = placeholder.querySelector('img');
      if (img) {
        placeholderData.push({
          src: img.src,
          alt: img.alt || 'Lifestyle image',
          mediaId: placeholder.dataset.mediaId
        });
      }
    });
    
    // Clear existing slides
    mobileSlidesContainer.innerHTML = '';
    
    const sectionId = pdpGalleryGrid.dataset.sectionId || '';
    let slideIndex = 0;
    
    // Add new slides with placeholders after first image
    filteredImages.forEach((data, index) => {
      const slide = document.createElement('div');
      slide.className = 'pdp-gallery-grid__mobile-slide';
      slide.setAttribute('data-media-id', `${sectionId}-${data.mediaId}`);
      slide.setAttribute('data-slide-index', String(slideIndex));
      
      const img = document.createElement('img');
      img.className = 'pdp-gallery-grid__mobile-img';
      // Use full src and build srcset
      const fullSrc = data.fullSrc || '';
      const baseSrc = fullSrc.replace(/width=\d+/, 'width=');
      img.src = baseSrc ? baseSrc.replace('width=', 'width=800') : fullSrc;
      img.srcset = baseSrc ? `
        ${baseSrc.replace('width=', 'width=400')} 400w,
        ${baseSrc.replace('width=', 'width=600')} 600w,
        ${baseSrc.replace('width=', 'width=800')} 800w
      ` : '';
      img.sizes = '100vw';
      img.alt = data.alt || '';
      img.loading = index === 0 ? 'eager' : 'lazy';
      
      slide.appendChild(img);
      mobileSlidesContainer.appendChild(slide);
      slideIndex++;
      
      // Insert placeholders after first image (if not accessory)
      if (index === 0 && !isAccessory && placeholderData.length > 0) {
        placeholderData.forEach((ph, phIndex) => {
          const placeholderSlide = document.createElement('div');
          placeholderSlide.className = 'pdp-gallery-grid__mobile-slide pdp-gallery-grid__mobile-slide--placeholder';
          placeholderSlide.setAttribute('data-media-id', ph.mediaId || `placeholder-${phIndex + 1}-${sectionId}`);
          placeholderSlide.setAttribute('data-slide-index', String(slideIndex));
          
          const phImg = document.createElement('img');
          phImg.className = 'pdp-gallery-grid__mobile-img';
          phImg.src = ph.src;
          phImg.alt = ph.alt;
          phImg.loading = 'lazy';
          
          placeholderSlide.appendChild(phImg);
          mobileSlidesContainer.appendChild(placeholderSlide);
          slideIndex++;
        });
      }
    });
    
    // Update progress bar total slides
    const totalSlides = slideIndex;
    if (mobileProgress) {
      mobileProgress.style.setProperty('--total-slides', totalSlides);
      mobileProgress.setAttribute('data-total-slides', totalSlides);
    }
    
    // Update counter
    if (mobileCounterTotal) {
      mobileCounterTotal.textContent = totalSlides;
    }
    if (mobileCounterCurrent) {
      mobileCounterCurrent.textContent = '1';
    }
    
    // Reset scroll position
    mobileSlidesContainer.scrollLeft = 0;
    
    // Reset progress bar position
    const progressBar = mobileSwiper.querySelector('.pdp-gallery-grid__mobile-progress-bar');
    if (progressBar) {
      progressBar.style.transform = 'translateX(0)';
      progressBar.style.width = `calc(100% / ${totalSlides})`;
    }
    
    // Re-initialize mobile swiper in pdpGalleryGrid
    if (typeof pdpGalleryGrid.initMobileSwiper === 'function') {
      pdpGalleryGrid.initMobileSwiper();
    }
  }

  // Update values delle product features al cambio variante
  updateFeatures() {
    if (!this.customCurrentVariant) return;
    
    let featureValueLensType = document.querySelector('.feature-item.feature--lens-type .feature-value-container .feature-value');
    let lensTypeTooltip = document.querySelector('.feature-item.feature--lens-type .feature-value-container .tw-tooltip-text p');

    if (featureValueLensType) {
      featureValueLensType.innerHTML = this.customCurrentVariant.lenstype;
      featureValueLensType.setAttribute('aria-label', this.customCurrentVariant.lenstype_tooltip);
    }

    if (lensTypeTooltip) {
      lensTypeTooltip.innerHTML = this.customCurrentVariant.lenstype_tooltip;
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && !this.querySelector('swiper-slider')) {
            if (this.classList.contains('complementary-products')) {
              this.remove();
            }
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);



/////////////////////////////////////////

/**
 * FGX-465 – Platform detection for express-checkout wallet visibility.
 *
 * Stamps one or more of the following classes on <html>:
 *   is-ipados   — iPad running iPadOS 13+ (presents Macintosh UA, but has touch)
 *   is-ios      — iPhone / iPod Touch (mutually exclusive with is-ipados)
 *   is-android  — Android devices (independent; never set alongside Apple classes)
 *
 * Used by base.css to hide incompatible wallet buttons:
 *   - Google Pay hidden on iOS / iPadOS
 *   - Apple Pay hidden on Android (not available on Android)
 *
 * macOS Safari and desktop Chrome are intentionally left unclassified so
 * Shopify's own payment eligibility logic governs which buttons appear.
 */
(function detectExpressCheckoutPlatform() {
  const ua = navigator.userAgent;
  const maxTouch = navigator.maxTouchPoints || 0;

  // iPadOS 13+ reports a Macintosh UA string but always has touch points.
  // Must be checked before the iPhone/iPod test to avoid false iOS matches.
  const isIPadOS = /Macintosh/.test(ua) && maxTouch > 1;
  const isIOS = !isIPadOS && /iPhone|iPod/.test(ua);
  const isAndroid = /Android/.test(ua);

  const root = document.documentElement;
  if (isIPadOS) root.classList.add('is-ipados');
  else if (isIOS) root.classList.add('is-ios');
  if (isAndroid) root.classList.add('is-android');
})();

